export const PRIVACY_ITEMS = [
  "Scope",
  "Changes to the Privacy Policy",
  "EMOS Usage Requirements",
  "Documentation Requests",
  "Availability",
  "Blocking and Termination of EMOS Access",
  "Disclaimer",
  "Governing Laws, Regulations, and Jurisdiction",
  "Severability",
  "Compliance with Regulations for Online Medical Device Distribution",
  "Force Majeure",
  "Policy Update",
];

export const USER_DATA_ITEMS = [
  "Definition of Personal Data",
  "Types of Personal Data",
  "Legality of Personal Data Processing",
  "Data Management and Transfer",
  "Users' Rights Regarding Personal Data",
  "User Consent for Personal Data Processing",
  "Revisions to the User Data Protection Policy",
  "EMOS Care",
  "Policy Update",
]; 